import { IoTimeOutline } from 'react-icons/io5'
import { IoIosCheckmarkCircleOutline } from 'react-icons/io'
import { RxCrossCircled } from 'react-icons/rx'
import { CustomerDetailData } from '../../interface/response/CustomerResponse'

export const CUSTOMER_STATUS = Object.freeze({
  PENDING: { key: 1, name: 'common.pending', eventKey: 'pending' },
  APPROVED: { key: 2, name: 'common.approved', eventKey: 'approved' },
  REJECTED: { key: 3, name: 'common.rejected', eventKey: 'rejected' },
})

export const customerTabs = [
  {
    key: CUSTOMER_STATUS.PENDING.key,
    eventKey: CUSTOMER_STATUS.PENDING.eventKey,
    title: CUSTOMER_STATUS.PENDING.name,
    icon: <IoTimeOutline size={20} />,
    disabled: false,
    tooltip: CUSTOMER_STATUS.PENDING.name,
  },
  {
    key: CUSTOMER_STATUS.APPROVED.key,
    eventKey: CUSTOMER_STATUS.APPROVED.eventKey,
    title: CUSTOMER_STATUS.APPROVED.name,
    icon: <IoIosCheckmarkCircleOutline size={20} />,
    disabled: false,
    tooltip: CUSTOMER_STATUS.APPROVED.name,
  },
  {
    key: CUSTOMER_STATUS.REJECTED.key,
    eventKey: CUSTOMER_STATUS.REJECTED.eventKey,
    title: CUSTOMER_STATUS.REJECTED.name,
    icon: <RxCrossCircled size={20} />,
    disabled: false,
    tooltip: CUSTOMER_STATUS.REJECTED.name,
  },
]

export const eventKeyToKeyMap = Object.fromEntries(
  Object.entries(CUSTOMER_STATUS).map(([_, value]) => [
    value.eventKey,
    value.key,
  ]),
)

export const CUSTOMER_APPROVAL_STATUS = Object.freeze({
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
})

export const customerAlertFormInitialValues = {
  reasonDescription: '',
}

export const setIntialValues = (info?: CustomerDetailData) => {
  return {
    customerName: info?.customerName ?? '',
    customerCode: info?.customerCode ?? '',
    contactNumber: info?.contactNumber ?? '',
    salesRep: info?.salesRep ?? '',
    address: info?.address ?? '',
    accountManager: info?.accountManager ?? '',
    country: info?.country ?? '',
    state: info?.state ?? '',
    city: info?.city ?? '',
    zipCode: info?.zipCode ?? '',
  }
}

export const customerDetailsFormInitialValues = {
  customerName: '',
  contactNumber: '',
  salesRep: '',
  address: '',
  accountManager: '',
  country: '',
  state: '',
  city: '',
  zipCode: '',
}
